import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { WhatYouGet } from './components/WhatYouGet';
import { Testimonials } from './components/Testimonials';
import { PriceClose } from './components/PriceClose';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { MobileCtaBar } from './components/MobileCtaBar';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream" data-id="element-0" data-mp="31ayqe1uk3nza">
      <UrgencyBar data-id="element-1" data-mp="31c1j8fbfw0hu" />
      <main data-id="element-2" data-mp="31cjou2jzrr2f">
        <Hero data-id="element-3" data-mp="2wka18t6cn33b" />
        <PainSection data-id="element-4" data-mp="2wjgq7g0cxrfd" />
        <WhatYouGet data-id="element-5" data-mp="2wj8cjlweui34" />
        <Testimonials data-id="element-6" data-mp="2wip7v6vrtq71" />
        <PriceClose data-id="element-7" data-mp="2wi5pxq64f1t0" />
        <Faq data-id="element-8" data-mp="28tw5osok2m3z" />
      </main>
      <Footer data-id="element-9" data-mp="28t4m6g88geu2" />
      <div className="h-20 md:hidden" aria-hidden="true" data-id="element-10" data-mp="28suv0pbgc1ms" />
      <MobileCtaBar data-id="element-11" data-mp="23vupcfiil0w7" />
    </div>;
}